import { ROOT_SECTION } from 'shared-base';
import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  background: #fff;

  a {
    color: #1a98f1;
    font-weight: 500;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Image = styled.div`
  flex: 1;
  background-image: url(${ROOT_SECTION('special')}/special_bk.png);
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ImageTop = styled.img`
  width: 90%;
`;

export const Google = styled.img`
  width: 20px;
`;

export const FinePrint = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 10px;
  text-align: center;
  width: 300px;
`;
